import React from 'react';
import styles from './OnboardingMocks.module.scss';

type Props = { highlightApprove?: boolean };

const OrdersSuccessMock: React.FC<Props> = ({ highlightApprove }) => (
  <div className={styles.shell} aria-hidden>
    <div className={styles.chrome}>
      <span className={styles.chromeDot} />
      <span className={styles.chromeDot} />
      <span className={styles.chromeDot} />
      <span>Ventas · MayorX</span>
    </div>
    <div className={styles.body}>
      <div className={styles.toolbar}>
        <span className={styles.toolbarTitle}>Pedidos</span>
        <span className={styles.pill}>+ Venta</span>
      </div>
      <div className={styles.row}>
        <div className={styles.rowMeta}>
          <div className={styles.rowName}>#219 · DISTRIBUIDORA ANDINA</div>
          <div className={styles.rowSub}>Efectivo · 3 ítems</div>
        </div>
        <div className={styles.rowRight}>
          <span
            className={
              highlightApprove ? styles.badgePending : styles.badge
            }
          >
            {highlightApprove ? 'Pendiente' : 'Aprobado'}
          </span>
          <div style={{ marginTop: 2 }}>$1,009.20</div>
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.rowMeta}>
          <div className={styles.rowName}>#216 · LA CASA DEL HARDWARE</div>
          <div className={styles.rowSub}>Transferencia · 5 ítems</div>
        </div>
        <div className={styles.rowRight}>
          <span className={styles.badge}>Aprobado</span>
          <div style={{ marginTop: 2 }}>$1,438.40</div>
        </div>
      </div>
    </div>
  </div>
);

export default OrdersSuccessMock;
